import { FeatureFlagName } from 'util/featureFlags'
import { CompatibilityParameters } from '../../types'

export const ULTRA_RAIL_COMPATIBILITY_PARAMS: CompatibilityParameters = {
  roofTypeRequired: true,
  roofTypes: [
    'Composition / Asphalt Shingle',
    'Flat Concrete',
    'Flat Foam',
    'Membrane EPDM',
    'Membrane PVC',
    'Membrane TPO',
    'Metal Shingle',
    'Metal Standing Seam',
    'Metal Tin',
    'Rolled Asphalt',
    'Tar and Gravel / Bitumen',
    'Tile Clay',
    'Tile Concrete',
    'Trapezoidal',
    'Wood/Shake Shingle',
  ],
  featureFlag: 'mounting_snapnrack_ultrarail' as FeatureFlagName,
  slopeRange: [0, 60],
}
